import React, { useState } from 'react';

import { ProjectSettingsMenuChoices } from '../ProjectSettingsPage/ProjectSettingsPage';
import VoxelMenu, { MenuItem } from '../../components/voxel/Menu/VoxelMenu';
import VoxelText from '../../components/voxel/Text/VoxelText';
import VoxelPanel from '../../components/voxel/Surfaces/VoxelPanel';
import VoxelHorPanelTab from '../../components/voxel/Tabs/VoxelHorPanelTab';
import VoxelHorTabContainer from '../../components/voxel/Tabs/VoxelHorTabContainer';
import VoxelUnderlinedTabs from '../../components/voxel/Tabs/VoxelUnderlinedTabs';

export interface NavsBoardProps { }

export const NavsBoard: React.FC<NavsBoardProps> = ({ }) => {

  const [selectedMenuItem, setSelectedMenuItem] = useState<ProjectSettingsMenuChoices>(ProjectSettingsMenuChoices.General);

  const menuItems: MenuItem[] = [
    { name: 'General', id: ProjectSettingsMenuChoices.General },
    { name: 'Data settings', id: ProjectSettingsMenuChoices.DataCollectionSettings },
    { name: 'Team access', id: ProjectSettingsMenuChoices.TeamAccess },
  ];

  return (
    <div className='mt-12 flex flex-col gap-8'>
      <div className='flex flex-col gap-6'>
        <VoxelText variant="title3" >Voxel menu</VoxelText>
        <VoxelMenu
          className='w-48'
          menuListItems={menuItems}
          selectedId={selectedMenuItem}
          setSelectedId={setSelectedMenuItem}
        />

      </div>
      <div className='flex flex-col gap-6'>
        <VoxelText variant="title3">Horizontal tabs</VoxelText>
        <div className="flex flex-col">
          <VoxelHorTabContainer>
            {menuItems.map((bt) => (
              <VoxelHorPanelTab
                key={bt.id}
                onClick={() => setSelectedMenuItem(bt.id)}
                active={selectedMenuItem === bt.id}
                title={bt.name}
              />
            ))}
          </VoxelHorTabContainer>
          <VoxelPanel paddingClass={'p-6 flex flex-row gap-12'} className={'rounded-tl-none'}>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
            Ipsum has been the industry's standard dummy text ever since the 1500s, when an
            unknown printer took a galley of type and scrambled it to make a type specimen
            book.
          </VoxelPanel>
        </div>
      </div>
      <VoxelText variant="title3" paddingBot>Horizontal tabs 2</VoxelText>
      <div>
        <VoxelUnderlinedTabs
          menuListItems={menuItems}
          selectedId={selectedMenuItem}
          setSelectedId={setSelectedMenuItem}
        />
        <VoxelPanel paddingClass='p-6' className={'rounded-tl-none'}>

          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
          Ipsum has been the industry's standard dummy text ever since the 1500s, when an
          unknown printer took a galley of type and scrambled it to make a type specimen
          book.

        </VoxelPanel>
      </div>
      <div className="">
        <VoxelUnderlinedTabs
          menuListItems={menuItems}
          selectedId={selectedMenuItem}
          setSelectedId={setSelectedMenuItem}
          size='xs'
        />
        <VoxelPanel paddingClass='p-6' className={'rounded-tl-none'}>
          <div className='my-2'>
            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
            Ipsum has been the industry's standard dummy text ever since the 1500s, when an
            unknown printer took a galley of type and scrambled it to make a type specimen
            book.
          </div>
        </VoxelPanel>
      </div>
    </div >

  );
};

export default NavsBoard;
